// @flow

import { RECEIVED_WP_SETTINGS } from './constants';
import type { ReceivedWpSettings } from './actions';
import type { Languages } from '../../types/settings';

const initialState = {
  site_name: '',
  site_description: '',
  language: '',
  available_languages: ([]: Languages),
};

export type State = typeof initialState;

const wpSettings = (state: State = initialState, action: ReceivedWpSettings): State => {
  switch (action.type) {
    case RECEIVED_WP_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default wpSettings;
